<template>
  <div class="upload" @mouseenter="btn=true" @mouseleave="btn=false">
    <el-button class="upload-btn" type="file" ref="file" v-show="btn">
      <span v-if="!noText">{{src==undefined||src==""?'上传图片':text}}</span>
    </el-button>
    <img v-if="src" :src="src" alt />
    <span class="add" v-if="!src&&!btn">+</span>
  </div>
</template>

<script>
import { getToken, getRoles } from '@/utils/auth'; // getToken from cookie
import plupload from 'plupload';
import { API_URL } from '@/utils/request';

export default {
  props: {
    src: String,
    noText: {
      default: false,
      type: Boolean,
    },
    text: {
      type: String,
      default: '更换头像',
    },
    data: Object,
    idx: [String, Number],
  },

  data: () => ({
    btn: false,
  }),

  computed: {},

  watch: {},

  mounted() {
    this.initUploader();
  },

  methods: {
    // 上传图片
    initUploader() {
      var uploader = new plupload.Uploader({
        browse_button: this.$refs.file.$el, //触发文件选择对话框的按钮，为那个元素id
        url: `${API_URL}?do=picture_add`, //服务器端的上传页面地址
        file_data_name: 'picture',
        multipart_params: {
          sid: getToken(),
          type: getRoles() == 'admin' ? 'admin' : 'taobaoke',
        },
        filters: {
          max_file_size: '10240kb',
        },
        resize: {
          quality: 60,
          preserve_headers: false,
        },
        max_retries: 2,
      });
      uploader.init();

      uploader.bind('FilesAdded', (uploader) => {
        uploader.start();
      });
      uploader.bind('FileUploaded', (uploader, file, responseObject) => {
        let data = JSON.parse(responseObject.response);
        if (data.error_code == 0) {
          this.uploader(data.file);
        } else {
          this.$message.error(data.error_message);
        }
      });
      uploader.bind('Error', (uploader, errObject) => {
        this.$message.error(errObject.message);
      });
    },

    // 上传图片
    uploader(filePath) {
      this.$emit('changeFace', filePath, this.idx, this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload {
  position: relative;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  .upload-btn {
    position: absolute;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4);
    border: none;
    outline: none;
    color: #fff;
    font-size: 14px;
  }
  img {
    width: 96px;
    height: 96px;
    border-radius: 50%;
  }
  .add {
    font-size: 35px;
    color: #8d9299;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>